import React from 'react';
import { PubSub } from '../../../utils/eventUtils';

const MODAL_CONTENT_RESET_DELAY_MS = 500;

const initialModalState = {
  config: {},
  component: () => null,
};

export const withModalState = (DialogBase: any) => {
  return () => {
    const [isOpen, setOpen] = React.useState(false);
    const [modal, setModal] = React.useState(initialModalState);
    const isOpenRef = React.useRef(false);
    const resetTimeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(
      null
    );

    const clearResetTimeout = () => {
      if (resetTimeoutRef.current !== null) {
        clearTimeout(resetTimeoutRef.current);
        resetTimeoutRef.current = null;
      }
    };

    const handleClose = () => {
      isOpenRef.current = false;
      setOpen(false);
      // Delay clearing content so the close animation can finish. A later
      // Modal.show() must cancel this — otherwise chained flows wipe the next
      // modal's body and leave an empty shell (open=true, no children).
      clearResetTimeout();
      resetTimeoutRef.current = setTimeout(() => {
        if (isOpenRef.current) {
          return;
        }
        setModal(initialModalState);
        resetTimeoutRef.current = null;
      }, MODAL_CONTENT_RESET_DELAY_MS);
    };

    React.useEffect(() => {
      const showSubscription = PubSub.subscribe(
        'modal:show',
        (nextModal: any) => {
          isOpenRef.current = true;
          clearResetTimeout();
          setOpen(true);
          setModal(nextModal);
        }
      );
      const hideSubscription = PubSub.subscribe('modal:hide', handleClose);

      return () => {
        clearResetTimeout();
        showSubscription.remove();
        hideSubscription.remove();
      };
    }, []);

    return (
      <DialogBase open={isOpen} onClose={handleClose} {...modal.config}>
        {React.createElement(modal.component, {
          // Extra props for the modal component, from Modal.show(config, { props }). Spread first so
          // data and close always come from the host.
          // @ts-expect-error TS(2339): Property 'props' does not exist on type '{ config: ...
          ...modal.props,
          // @ts-expect-error TS(2339): Property 'data' does not exist on type '{ config: ... Remove this comment to see the full error message
          data: modal.data,
          close: handleClose,
        })}
      </DialogBase>
    );
  };
};
